
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/sqlserver",
      function () {
        return require("private-next-pages/sources/sqlserver.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/sqlserver"])
      });
    }
  